"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spire = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
const DiscardCards_1 = require("../../deferredActions/DiscardCards");
const ResourceType_1 = require("../../ResourceType");
class Spire extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.SPIRE,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.EARTH],
            startingMegaCredits: 50,
            resourceType: ResourceType_1.ResourceType.SCIENCE,
            initialActionText: 'Draw 4 cards, then discard 3 cards',
            metadata: {
                cardNumber: '??',
                description: 'You start with 50 M€. As your first action, draw 4 cards, then discard 3 cards.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(50).nbsp(Size_1.Size.SMALL).plus().cards(4).digit.minus().cards(3).digit;
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.diverseTag(2).asterix().startEffect.science(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('When you play a card with at least 2 tags, including this, add 1 science resource here. Science resources here may be used as 2 M€ each for standard projects.', (eb) => {
                            eb.plate('Standard projects', Size_1.Size.SMALL).startEffect.science(1).equals().megacredits(2);
                        });
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        this.onCorpCardPlayed(player, this);
        return undefined;
    }
    initialAction(player) {
        player.drawCard(4);
        player.game.defer(new DiscardCards_1.DiscardCards(player, 3));
        return undefined;
    }
    onCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    onCorpCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    _onCardPlayed(player, card) {
        if (!player.isCorporation(this.name))
            return undefined;
        const count = card.tags.length + (card.cardType === CardType_1.CardType.EVENT ? 1 : 0);
        if (count >= 2) {
            player.addResourceTo(this, { log: true });
        }
        return undefined;
    }
}
exports.Spire = Spire;
//# sourceMappingURL=Spire.js.map